export default __webpack_public_path__ + "media/zurb/img/legacy/icons/press/webappers-b5285571f03fe5ec8ec8b213931c4a24.png";